import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";

import contactImg from '../assets/images/contact.svg'
import toast from "react-hot-toast";
import { FiPhone, FiMail, FiMapPin, FiX } from '../assets/icons/vander'
import ScrollToTop from "../components/scroll-to-top";
//  import {fetchcontactus } from "../ApiService/Contactus/Contactus";
import { fetchbusinessinfo,sendContactForm } from "../ApiService/orderusapi/orderusapi"
import{fetchaboutus} from "../ApiService/aboutus/aboutus"




export default function Contact() {
    let [modal, setModal] = useState(false)
    let [contactData, setContactData] = useState(null);
   let [iframedata, setIframeData] = useState(null);
   let [mapLoading, setMapLoading] = useState(true); // Separate loading state for the map
    let [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  let [loading, setLoading] = useState(false);



    useEffect(() => {
        const getContact = async () => {
            try {
                setMapLoading(true); // Start loading
                const data = await fetchaboutus();
                console.log("API Response for aboutus:", data); // <-- DEBUG: Log the response
                setIframeData(data);
            } catch (error) {
                console.error("Error fetching aboutus data:", error);
                toast.error("Could not load map location.");
            } finally {
                setMapLoading(false); // Stop loading regardless of outcome
            }
        };
        getContact();
    }, []);

    useEffect(() => {
        const getContact = async () => {
            try {
                const data = await fetchbusinessinfo();
                setContactData(data[0]);
            } catch (error) {
                console.error(error);
            }
        };
        getContact();
    }, []);


     const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // basic validation
    if (!formData.name || !formData.email || !formData.subject) {
      toast.error("Please fill all required fields!");
      return;
    }

     try {
      setLoading(true);
      const response = await sendContactForm({
        name: formData.name,
        email: formData.email,
        subject: formData.subject, // API expects 'message'
        message: formData.message,
      });

      if (response?.message) {
        toast.success(response.message || "Message sent successfully!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      toast.error("Failed to send message. Try again!");
    } finally {
      setLoading(false);
    }
  };

  // Helper function
const getIframeSrc = (iframeString) => {
        if (!iframeString) return null;

        // Check if it's already a URL (starts with http)
        if (iframeString.startsWith('http')) {
            return iframeString;
        }

        // Otherwise, try to extract the src from an HTML string
        const match = iframeString.match(/src="([^"]+)"/);
        return match ? match[1] : null;
    };

    // Safely get the iframe source
    const iframeSrc = getIframeSrc(iframedata?.stores?.[0]?.iframe_location);

    return (
        <>
            <Navbar navClass="defaultscroll is-sticky h-[70px]" />
            <div className="container-fluid relative mt-20">
  <div className="w-full h-[500px]">
  {mapLoading ? (
                        // Show a loading message while fetching data
                        <p className="text-center text-gray-400 py-20">Loading map...</p>
                    ) : iframeSrc ? (
                        // Render iframe ONLY if we have a valid source URL
                        <iframe
                            src={iframeSrc}
                            title="store-location"
                            width="100%"
                            height="500"
                            className="border-0"
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    ) : (
                        // Show an error message if data is loaded but no iframe URL is found
                        <p className="text-center text-red-400 py-20">Map location is currently unavailable.</p>
                    )}
</div>


</div>

            <section className="relative lg:py-24 py-16">
                <div className="container">
                    <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
                        <div className="lg:col-span-7 md:col-span-6">
                            <img src={contactImg} alt="" />
                        </div>

                        <div className="lg:col-span-5 md:col-span-6">
                            <div className="lg:ms-5">
                                <div className="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-700 p-6">
                                    <h3 className="mb-6 text-2xl leading-normal font-semibold">Get in touch !</h3>

                                    <form onSubmit={handleSubmit}>
                    <div className="grid lg:grid-cols-12 grid-cols-1 gap-3">
                      <div className="lg:col-span-6">
                        <label htmlFor="name" className="font-semibold">
                          Your Name:
                        </label>
                        <input
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          type="text"
                          className="mt-2 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800"
                          placeholder="Name :"
                        />
                      </div>

                      <div className="lg:col-span-6">
                        <label htmlFor="email" className="font-semibold">
                          Your Email:
                        </label>
                        <input
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          type="email"
                          className="mt-2 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800"
                          placeholder="Email :"
                        />
                      </div>

                      <div className="lg:col-span-12">
                        <label htmlFor="subject" className="font-semibold">
                          Your Question:
                        </label>
                        <input
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          className="mt-2 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800"
                          placeholder="Subject :"
                        />
                      </div>

                      <div className="lg:col-span-12">
                        <label htmlFor="message" className="font-semibold">
                          Your Message:
                        </label>
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          className="mt-2 w-full py-2 px-3 h-28 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800"
                          placeholder="Message :"
                        ></textarea>
                      </div>
                    </div>

                    <button
                      type="submit"
                      disabled={loading}
                      className={`py-2 px-5 inline-block tracking-wide text-base text-center text-white rounded-md mt-2 ${
                        loading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-orange-500 hover:bg-orange-600"
                      }`}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container lg:mt-24 mt-16">
                    <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6">
                        <div className="text-center px-6">
                            <div className="relative text-transparent">
                                <div className="size-20 bg-orange-500/5 text-green-500 rounded-xl text-2xl flex align-middle justify-center items-center mx-auto shadow-sm dark:shadow-gray-800">
                                    <FiPhone />
                                </div>
                            </div>

                            <div className="content mt-7">
                                <h5 className="title h5 text-lg font-semibold">Phone</h5>
                                {/* <p className="text-slate-400 mt-3">The phrasal sequence of the is now so that many campaign and benefit</p> */}

                                <div className="mt-5">
                                    <Link to="tel:+152534-468-854" className="text-green-500 font-medium">{contactData?.toll_free_number || "NA"}</Link>
                                </div>
                            </div>
                        </div>

                        <div className="text-center px-6">
                            <div className="relative text-transparent">
                                <div className="size-20 bg-orange-500/5 text-green-500 rounded-xl text-2xl flex align-middle justify-center items-center mx-auto shadow-sm dark:shadow-gray-800">
                                    <FiMail />
                                </div>
                            </div>

                            <div className="content mt-7">
                                <h5 className="title h5 text-lg font-semibold">Email</h5>
                                {/* <p className="text-slate-400 mt-3">The phrasal sequence of the is now so that many campaign and benefit</p> */}

                                <div className="mt-5">
                                    <Link to={contactData?.email} className="text-green-500 font-medium">{contactData?.email || "NA"}</Link>
                                </div>
                            </div>
                        </div>

                        <div className="text-center px-6">
                            <div className="relative text-transparent">
                                <div className="size-20 bg-orange-500/5 text-green-500 rounded-xl text-2xl flex align-middle justify-center items-center mx-auto shadow-sm dark:shadow-gray-800">
                                    <FiMapPin />
                                </div>
                            </div>

                            <div className="content mt-7">
                                <h5 className="title h5 text-lg font-semibold">Location</h5>
                                <p className="text-slate-400 mt-3">{contactData?.address || "NA"}</p>

                                {/* <div className="mt-5">
                                    <Link to="#" onClick={() => setModal(true)}
                                        data-type="iframe" className="video-play-icon read-more lightbox text-green-500 font-medium">View on Google map</Link>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Switcher />
            {modal && (
                <div className="w-full h-screen bg-slate-900/80 fixed top-0 left-0 bottom-0 right-0 z-999 flex items-center justify-center">
                    <div className="w-full h-full px-5 md:px-40 md-py-20 py-5">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d55431.05581015953!2d-95.461302!3d29.735948000000004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c36647a52ab1%3A0x70a301678672cb!2sBriargrove%20Park%2C%20Houston%2C%20TX%2C%20USA!5e0!3m2!1sen!2sin!4v1710322657489!5m2!1sen!2sin" width="100%" height="100%" title="myfram" loading="lazy"></iframe>
                    </div>
                    <button className="text-slate-400 absolute top-[20px] right-[20px]" onClick={() => setModal(false)}>
                        <FiX className="size-5" />
                    </button>
                </div>
            )}
            <ScrollToTop />
        </>
    )
}